import { Kysely, ParseJSONResultsPlugin } from 'kysely'
import type { DB } from './kysely-d'
import { SqlJsDialect } from '@/lib/custom-driver'

export const DataBase = new Kysely<DB>({
  dialect: new SqlJsDialect(),
  plugins: [new ParseJSONResultsPlugin()]
})
